const s = {
  name: "EmailReset",
  dimensions: { width: 40, height: 32 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 32" style="enable-background:new 0 0 40 32;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M3.6,30H20v2H3c-1.7,0-3-1.3-3-3V3c0-1.7,1.3-3,3-3h34c1.7,0,3,1.3,3,3v13h-2V3.2L20,19.3l-2.2-2L3.6,30z
			 M2,3.2v25.5L16.3,16L2,3.2z M36.4,2H3.6l14.8,13.3l1.6,1.4L36.4,2z"/>
		<path class="st0" d="M26,25c0-3.9,3.1-7,7-7s7,3.1,7,7s-3.1,7-7,7v-2c2.8,0,5-2.2,5-5s-2.2-5-5-5c-2.8,0-5,2.2-5,5v1.6l2.3-2.3
			l1.4,1.4L27,30.4l-4.7-4.7l1.4-1.4l2.3,2.3V25z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as EmailReset
};
